import { render, staticRenderFns } from "./TenantFooter.vue?vue&type=template&id=7c0ce81b&scoped=true&"
import script from "./TenantFooter.vue?vue&type=script&lang=js&"
export * from "./TenantFooter.vue?vue&type=script&lang=js&"
import style0 from "./TenantFooter.vue?vue&type=style&index=0&id=7c0ce81b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0ce81b",
  null
  
)

export default component.exports